var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneRotate2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.013,
    height: 35.085,
    viewBox: "0 0 24.013 35.085",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phone_Rotate",
    transform: "translate(-7.425 0.111)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Smart_Phone",
    transform: "translate(8.432 0.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M10.707,3.126,22.771.981A2.7,2.7,0,0,1,25.931,3.2L30.383,28.59a2.691,2.691,0,0,1-2.226,3.147L16.093,33.883a2.7,2.7,0,0,1-3.16-2.217L8.481,6.274A2.727,2.727,0,0,1,10.707,3.126Z",
    transform: "translate(-8.432 -0.932)",
    fill: "none",
    stroke: "#00105c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 1.365,
    cy: 1.365,
    r: 1.365,
    transform: "translate(11.675 28.034) rotate(-9.997)",
    fill: "#00105c"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    y1: 3.018,
    x2: 17.387,
    transform: "translate(4.061 25)",
    fill: "none",
    stroke: "#00105c",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneRotate2);
export default __webpack_public_path__ + "static/media/Phone_Rotate-2.5c85c992e9fbb61adbefadc2ad06dfaf.svg";
export { ForwardRef as ReactComponent };